import React from 'react'

const ModuleIconSelectorContainer: React.FC = ({ children }) => {

    return <div className = "moduleIconSelectorContainer">{children}</div>

}

export default ModuleIconSelectorContainer